<div id="sensors-search-bar" class="float-left">
  <div class="input-group">
    <span class="input-group-addon">
      <button type="submit" id="sensors-search-button">
        <i class="fa fa-search" aria-hidden="true"></i>
      </button>
      <input type="text" class="form-control" id="sensors-search-input" [placeholder]="placeholderTitle"
             [(ngModel)]="searchTerm" (ngModelChange)="updateDisplayDataEventEmitter()">
    </span>
  </div>
</div>
